import React from 'react';

const PageBannersTab = ({ banners, products = [], onOpenModal, getImageUrl }) => {
    const mainBannerItems = [
        { key: 'about-us', name: 'About Us Page Banner', fallbackImg: '/images/banner/5.jpg', fallbackTitle: 'About bs clads', fallbackDesc: 'Pioneering architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions in Coimbatore since 2010.' },
        { key: 'products', name: 'Products Page Banner', fallbackImg: '/images/banner/6.jpg', fallbackTitle: 'Our Products', fallbackDesc: 'Explore our comprehensive range of high-performance architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions by bs clads.' },
        { key: 'projects', name: 'Projects Page Banner', fallbackImg: '/images/banner/1.jpg', fallbackTitle: 'Completed Projects Gallery', fallbackDesc: 'Explore our portfolio of commercial architectural elevations, showroom cladding, and structural glass facades.' },
        { key: 'contact-us', name: 'Contact Us Page Banner', fallbackImg: '/images/banner/9.jpg', fallbackTitle: 'Get in Touch with bs clads', fallbackDesc: 'Get in touch with bs clads for expert ACP Front Elevation, Facade Glazing, and Toughened Glass inquiries.' }
    ];

    // Individual product banners derived from products list
    const productBannerItems = products.map(p => {
        const slugKey = p.slug || (p.title ? p.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : `prod-${p.id}`);
        return {
            key: slugKey,
            name: `Product Banner: ${p.title}`,
            fallbackImg: p.mainImage || '/images/products/acp_cladding.jpg',
            fallbackTitle: p.title,
            fallbackDesc: p.shortDesc || `Premium ${p.title} solutions in Coimbatore by bs clads.`
        };
    });

    const renderBannerCard = (item) => {
        const currentData = banners[item.key] || {};
        const title = currentData.title || item.fallbackTitle;
        const desc = currentData.description || item.fallbackDesc;
        const bgImg = getImageUrl(currentData.bgImage || item.fallbackImg);

        return (
            <div key={item.key} className="bg-white bdr-gray-light bdr-solid bdr-1" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.06)' }}>
                <div style={{ height: '150px', position: 'relative', overflow: 'hidden', backgroundColor: '#1e293b', backgroundImage: `url("${bgImg}"), linear-gradient(135deg, #1e293b 0%, #0f172a 100%)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)' }} />
                    <div style={{ position: 'absolute', bottom: '15px', left: '15px', right: '15px', color: '#ffffff', zIndex: 2 }}>
                        <span className="admin-pill bg-orange m-b5" style={{ display: 'inline-block', fontSize: '11px' }}>{item.name}</span>
                        <h4 style={{ margin: 0, color: '#ffffff', fontWeight: '700', fontSize: '16px' }}>{title}</h4>
                    </div>
                </div>
                <div style={{ padding: '16px' }}>
                    <p style={{ fontSize: '13px', color: '#666', lineHeight: '1.5', minHeight: '40px', margin: '0 0 15px 0' }}>
                        {desc}
                    </p>
                    <button
                        type="button"
                        className="admin-btn admin-btn-primary"
                        style={{ width: '100%', justifyContent: 'center' }}
                        onClick={() => onOpenModal('banner', { key: item.key, name: item.name, title, description: desc, bgImage: currentData.bgImage || item.fallbackImg })}
                    >
                        <i className="fa fa-pencil m-r5" /> Edit Banner
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="admin-tab-content">
            {/* MAIN WEBSITE PAGE BANNERS */}
            <div className="admin-card m-b30">
                <div className="card-header">
                    <h3><i className="fa fa-flag m-r10" style={{ color: '#f03a02' }} /> Main Website Page Banners</h3>
                </div>
                <div className="card-body">
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                        {mainBannerItems.map(renderBannerCard)}
                    </div>
                </div>
            </div>

            {/* INDIVIDUAL PRODUCT PAGE BANNERS */}
            <div className="admin-card">
                <div className="card-header">
                    <h3><i className="fa fa-cubes m-r10" style={{ color: '#f03a02' }} /> Product Detail Page Banners ({productBannerItems.length})</h3>
                </div>
                <div className="card-body">
                    {productBannerItems.length === 0 ? (
                        <p style={{ color: '#888', fontStyle: 'italic' }}>No products found to manage product banners.</p>
                    ) : (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                            {productBannerItems.map(renderBannerCard)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageBannersTab;
